export default {
  lang: { name: 'English', code: 'en', flag: '🇬🇧' },
  common: {
    whatsapp: 'WhatsApp',
    email: 'Email',
    sendEmail: 'Send Email',
    sendInquiry: 'Send Inquiry',
    contactSupplier: 'Contact Supplier',
    viewDetails: 'View Details',
    viewAll: 'View All',
    loading: 'Loading…',
    backHome: 'Back to Home',
    negotiable: 'Price negotiable',
    perPiece: '/ piece',
    moq: 'MOQ: 1 piece',
    inStock: 'In Stock',
    refresh: 'refresh',
    chatNow: 'Chat Now',
    chooseContact: 'Choose a sales contact',
    notFound: 'No results found'
  },
  nav: {
    home: 'Home',
    products: 'Products',
    examples: 'Examples',
    about: 'About Us',
    contact: 'Contact Us'
  },
  header: {
    callUs: 'Call us',
    quickNav: 'Quick Navigation',
    tapExpand: 'Tap to expand',
    tapClose: 'Tap to close',
    language: 'Language'
  },
  hero: {
    tag: 'Stage Lighting Manufacturer · Since 2010',
    title: 'Illuminate Every Stage<br>With Professional Lighting',
    sub: 'High-quality stage lighting solutions — moving head, par, strobe and LED. Exported to over 50 countries.',
    browseProducts: 'Browse Products',
    chatWa: 'Chat on WhatsApp'
  },
  quicknav: {
    title: 'Quick Navigation',
    products: 'Products',
    productsDesc: 'Browse all stage lighting',
    examples: 'Examples',
    examplesDesc: 'Real project showcases',
    about: 'About Us',
    aboutDesc: 'Factory & company profile',
    contact: 'Contact Sales',
    contactDesc: 'WhatsApp for fast quote'
  },
  featured: {
    eyebrow: 'HOT SELLING',
    title: 'Featured Products',
    desc: 'Our most popular stage lighting — trusted by customers in over 50 countries.',
    viewAll: 'View All Products',
    badge: 'Hot',
    empty: 'No featured products available right now.'
  },
  sections: {
    whyEyebrow: 'WHY CHOOSE US',
    whyTitle: 'Our Advantages',
    whyDesc: 'With extensive experience, we excel in both innovation and large-scale production, ensuring high-quality stage lighting solutions that meet global standards.',
    svcEyebrow: 'WHAT WE OFFER',
    svcTitle: 'Our Services',
    svcDesc: 'A comprehensive range of stage lighting solutions — from customized products to global shipping and remote technical support.',
    contactEyebrow: 'CONTACT US',
    contactTitle: 'Send an Inquiry',
    contactDesc: 'Prefer email? Leave your details and we\'ll get back to you within 24 hours.'
  },
  cta: {
    title: 'Need a quote within minutes?',
    desc: 'Message us on WhatsApp — our sales team typically replies within 10 minutes during working hours.',
    emailUs: 'Email us'
  },
  product: {
    heroTitle: 'Products',
    heroDesc: 'High-quality stage lighting with flexible control, exceptional stability and reliable safety — built to elevate every performance and event.',
    searchPlaceholder: 'Search products by keyword...',
    search: 'Search',
    sortBy: 'Sort by',
    sortDefault: 'Default',
    sortNewest: 'Newest',
    sortAsc: 'Price: Low to High',
    sortDesc: 'Price: High to Low',
    categories: 'Categories',
    results: 'products',
    in: 'in',
    filterToggle: 'Categories',
    allTypes: 'All',
    noImg: 'None'
  },
  productDetails: {
    loadingProduct: 'Loading product…',
    notFound: 'Product not found.',
    backToProducts: '← Back to Products',
    keyAttributes: 'Key attributes',
    moreSpecs: 'more specifications',
    blockDescription: 'Product Description',
    noDescription: 'No description provided.',
    blockSpecs: 'Specifications',
    noSpecs: 'No specifications available.',
    blockFaq: 'Frequently Asked Questions',
    inquiryTitle: 'Send an inquiry',
    inquiryDesc: 'Tell us what you need — we typically reply within 24 hours.',
    priceMeta: 'MOQ: 1 piece · Bulk discounts available'
  },
  example: {
    heroTitle: 'Project Examples',
    heroDesc: 'Real installations and stage productions powered by our lighting solutions worldwide.',
    ctaWa: 'Get a similar setup',
    empty: 'No examples in this category yet.'
  },
  about: {
    heroTitle: 'About Us',
    heroSub: 'Guangzhou Huayang Stage Lighting — a dedicated manufacturer of professional stage lighting since 2010.',
    companyEyebrow: 'OUR COMPANY',
    purposeEyebrow: 'OUR PURPOSE',
    purposeTitle: 'Illuminating Stages, Shining the Future',
    teamEyebrow: 'CONTACT OUR TEAM',
    teamTitle: 'Customer Service',
    teamDesc: 'Reach our sales specialists directly — WhatsApp is the fastest way to get a quote.',
    notSure: 'Not sure who to talk to?',
    routeMsg: 'Message our main line and we\'ll route you to the right person.',
    leaveEyebrow: 'OR SEND A MESSAGE',
    leaveTitle: 'Leave Your Details',
    leaveDesc: 'Email is also welcome — we reply within 24 hours.',
    statYears: 'Years',
    statCountries: 'Countries',
    statUnits: 'Units / Year',
    statFactory: 'm² Factory',
    whyList1: 'Factory direct pricing',
    whyList2: 'Global shipping supported',
    whyList3: 'Quality guaranteed'
  },
  footer: {
    productCenter: 'Product Center',
    viewAllProducts: 'View All Products',
    aboutTitle: 'About Us',
    aboutText: 'Guangzhou Huayang Stage Lighting, founded in 2010, specializes in stage lighting equipment like moving head lights and LED lights. Exporting to over 50 countries, we are known for high-quality products and excellent customer service.',
    contact: 'Contact',
    chatWa: 'Chat on WhatsApp',
    rights: 'All rights reserved.',
    waLabel: 'fastest reply',
    workingHours: 'Working hours'
  },
  leaveMessage: {
    fastest: 'Fastest reply',
    title: 'Message us on WhatsApp',
    replyMin: 'Our sales team typically replies within <b>10 minutes</b> during working hours ({hours}).',
    orEmail: 'or send an email',
    formTitle: 'Send us an email',
    formSub: 'Fill in the form below — we reply within 24 hours.',
    fullName: 'Full Name *',
    fullNamePh: 'Your name',
    phone: 'Phone Number *',
    phonePh: 'Include country code',
    emailLbl: 'Email Address *',
    emailPh: 'you@example.com',
    message: 'Your Message *',
    messagePh: "Tell us what products you're interested in, quantities, destination, etc.",
    codePh: 'Enter Verification Code',
    privacy: 'Your information is kept private and used only to respond to your inquiry.',
    errCode: 'Please enter the verification code.',
    errForm: 'Please provide complete and valid information.',
    okSent: 'Your message has been submitted successfully!',
    errCodeInvalid: 'Invalid verification code, please try again.',
    errFail: 'Message submission failed. Please try again later.'
  },
  trust: {
    assurance: 'Trade Assurance',
    assuranceDesc: 'Built-in order protection',
    shipping: 'Global Shipping',
    shippingDesc: 'Sea / Air / Express',
    quality: 'Quality Checked',
    qualityDesc: 'Factory direct'
  },
  stats: {
    years: '14+',
    yearsLbl: 'Years',
    countries: '50+',
    countriesLbl: 'Countries',
    units: '100k+',
    unitsLbl: 'Units / Year',
    factory: '7200',
    factoryLbl: 'm² Factory'
  }
};
